<template>
  <v-app id="inspire" class="main-view">
    <template v-if="ok">
      <default-app-bar/>
      <default-menu-left/>
      <default-settings/>
      <div class="px-6">
        <default-view/>
      </div>
    </template>
    <overlay-loading/>
  </v-app>
</template>

<script>
import DefaultAppBar from './AppBar'
import DefaultMenuLeft from './MenuLeft'
import DefaultSettings from './Settings'
import DefaultView from './View'
import OverlayLoading from '../components/OverlayLoading'
import request from '@utils/request'
import { call, get } from 'vuex-pathify'

export default {
  name: 'DefaultLayout',
  components: {
    DefaultAppBar,
    DefaultMenuLeft,
    DefaultSettings,
    DefaultView,
    OverlayLoading
  },
  data: () => ({
    ok: false
  }),
  computed: {
    loggedInStatus: get('auth/loggedInStatus')
  },
  async created() {
    this.loading(true)
    if (this.loggedInStatus) {
      request.setAuthHeader()
      try {
        await this.getUserProfile()
        this.ok = true
      } catch (e) {
      }
      this.loading(false)
    } else {
      this.$router.push({ replace: true, name: 'auth.login' })
    }
  },
  methods: {
    loading: call('app/setLoading'),
    getUserProfile: call('user/getUserProfile')
  }
}
</script>
